import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import './_CopySection.scss';
import { CopyHOC } from '../../hocs/CopyHOC/CopyHOC';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';
import { COPY_SECTION_TITLE } from './constants';
import { ICopySectionProps } from './types';

export function CopySection ({
}: ICopySectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--copy';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.COPY} />
            <SettingsSection
                className={className}
                title={COPY_SECTION_TITLE}
            >
                <CopyHOC
                    boardId={boardId}
                />
            </SettingsSection>
        </>
    );
};
